import { Box } from '@mui/material';
import { ReactNode } from 'react';

export interface SocialExportUploadLayoutProps {
  /** Platform switcher section. */
  platform: ReactNode;
  /** Media selector (and optional empty node when hidden). */
  media: ReactNode;
  /** Video preview; sticky on the right from md up, under media on smaller screens. */
  preview: ReactNode;
  /** Account selector, limits alerts, publish form, and related messages. */
  form: ReactNode;
}

/**
 * Two-column social export upload layout.
 * Below md: platform → media → preview → form.
 * From md up: form sections on the left, sticky preview column on the right.
 */
export function SocialExportUploadLayout({
  platform,
  media,
  preview,
  form,
}: SocialExportUploadLayoutProps) {
  return (
    <Box
      sx={{
        display: 'grid',
        columnGap: 4,
        gridTemplateColumns: {
          xs: '1fr',
          md: 'minmax(0, 7fr) minmax(0, 5fr)',
        },
        gridTemplateAreas: {
          xs: `
            "platform"
            "media"
            "preview"
            "form"
          `,
          md: `
            "platform preview"
            "media preview"
            "form preview"
          `,
        },
      }}
    >
      <Box sx={{ gridArea: 'platform' }}>{platform}</Box>
      <Box sx={{ gridArea: 'media' }}>{media}</Box>
      <Box
        sx={{
          gridArea: 'preview',
          alignSelf: 'start',
          position: { md: 'sticky' },
          top: { md: 16 },
        }}
      >
        {preview}
      </Box>
      <Box sx={{ gridArea: 'form' }}>{form}</Box>
    </Box>
  );
}
